export default __webpack_public_path__ + "media/66176fa3896c122942a8f65116ea9d0eb7fe1f71a01bfd78f8edd6e12c28fd61.svg";